import type { EtapeRecherche } from './recherche.js';

const rec = (code: string, libelle: string): EtapeRecherche => ({ code, libelle, etat: 'a_faire', motif: null });

/**
 * Données versionnées de l’écran Dossier (referentiel-metier.md §1.6) : seuil PAR-36, parcours REF-REC, délai
 * d’inactivité du chronomètre (RG-24). Ces valeurs seront servies par le référentiel (D10) quand la RFC-L53-001
 * sera appliquée ; en attendant, elles vivent ici, datées, et jamais dans la logique. Le délai d’inactivité est
 * provisoire : il fera l’objet d’une question BETA.
 */
export const REFERENTIEL_L53 = {
  version: '2026-10-26',
  seuilTitreAncien: 1970,
  inactiviteChronoMs: 300_000,
  /**
   * Étape du squelette P0 à P9 à laquelle sert chaque bloc propre à une étape de la vue d'ensemble (affichage progressif,
   * PARITE-2). Hors de son étape, un bloc est replié (étape passée) ou seulement annoncé (étape à venir). À valider par
   * Isabelle ; servi par le référentiel (D10) quand la RFC-L53-001 sera appliquée.
   */
  blocsParPhase: { forfait: 'P2', recherche: 'P5' } as const,
  recherche: [
    rec('REC-01', 'Relevé de propriété DGFiP'),
    rec('REC-02', 'Fiche immeuble'),
    rec('REC-03', 'Fiche personnelle'),
    rec('REC-04', 'Acte par volume et numéro'),
    rec('REC-05', 'Déplacement si mauvais acte'),
    rec('REC-06', 'Archives avant 1956'),
    rec('REC-07', 'Pré-étude de concordance'),
    rec('REC-08', 'Prescription acquisitive'),
  ] as readonly EtapeRecherche[],
} as const;
